import { render, staticRenderFns } from "./pageEditButtonComponent.vue?vue&type=template&id=76d4891b&scoped=true&"
import script from "./pageEditButtonComponent.vue?vue&type=script&lang=js&"
export * from "./pageEditButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./pageEditButtonComponent.vue?vue&type=style&index=0&id=76d4891b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d4891b",
  null
  
)

export default component.exports